<template>
  <div :style="style">
    <img :src="url" alt=""  v-if="src">
    <div class="default" :style="{ borderRadius:this.border}">
      <i class="el-icon-loading"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "RlImg",
  data() {
    return {
      style: {
        width: this.width,
        height: this.height,
        overflow: 'hidden',
        borderRadius: this.border,
      }
    }
  },
  computed: {
    url() {
      if('http://'.indexOf(this.src) !== -1) {
        return this.src
      } else {
        return 'http://'+ this.src
      }
    }
  },
  props:{
    src:{
      type: String,
      require: true,
    },
    width:{
      type: String,
      default:'100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    border: {
      type : String,
      default: '4px 4px 0 0'
    }
  }
}
</script>

<style lang="less" scoped>
img{
  width: 100%;
  height: 100%;
  object-fit: cover;
  &:hover{
    transform: scale(1.02);
    transition: all 0.3s ease-out;
  }
}
.default {

  width: 100%;
  height: 100%;
  background-color: var(--bg-color);
  display: flex;
  align-items: center;
  justify-content: center;
  i{
    font-size: 4em;
    color: var(--first-text);
  }
}
</style>